/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ChangeTimezoneRequest {
    getFixupPrototypeFunction() { return ChangeTimezoneRequest.fixupPrototype; }

    static newInstance(model: Partial<ChangeTimezoneRequest>): ChangeTimezoneRequest {
        let obj = Object.assign(new ChangeTimezoneRequest(), model);
        ChangeTimezoneRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ChangeTimezoneRequest>): ChangeTimezoneRequest {
        if (!model) return null;
        return ChangeTimezoneRequest.newInstance(<ChangeTimezoneRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ChangeTimezoneRequest) {
        if (!obj) return;

        models.ChangeTimezoneRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ChangeTimezoneRequest): boolean {
        Object.setPrototypeOf(obj, ChangeTimezoneRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * New timezone id to be set for the user. For a valid list of timezone values to use, please refer https://en.wikipedia.org/wiki/List_of_tz_database_time_zones
     */
    new_timezone_id: string;

}
